import {
  WALLET_TRANSACTION_TYPE_LABELS,
  WalletPaymentMethod,
  WalletTransactionDirection,
  WalletTransactionGateway,
  WalletTransactionStatus,
  WalletTransactionType,
} from "@/types/TransactionsType"

export const getStatusConfig = (status: WalletTransactionStatus): {
  color: "green" | "yellow" | "orange" | "purple" | "blue" | "gray"; label: string
} => {
  switch (status) {
    case "COMPLETED":
    case "VALIDATED":
      return { color: "green", label: "Succès" }
    case "PENDING":
      return { color: "purple", label: "En attente" }
    case "IN_PROGRESS":
      return { color: "blue", label: "En cours" }
    case "FAILED":
      return { color: "yellow", label: "Échouée" }
    case "REJECTED":
      return { color: "orange", label: "Rejétée" }
    case "CANCELED":
      return { color: "gray", label: "Annulée" }
    default:
      return { color: "gray", label: status }
  }
}

export const getPaymentMethodConfig = (payment_method: WalletPaymentMethod): {
  color: "green" | "yellow" | "purple" | "blue" | "gray"; label: string
} => {
  switch (payment_method) {
    case "MOMO":
      return { color: "green", label: "Dépôt Mobile Money" }
    case "CARD":
      return { color: "purple", label: "Carte bancaire" }
    case "BANK_TRANSFER":
      return { color: "blue", label: "Transfert Bancaire" }
    case "CHECK":
      return { color: "gray", label: "Dépôt de Chèque" }
    default:
      return { color: "gray", label: payment_method }
  }
}

export const getGatewayConfig = (payment_gateway: WalletTransactionGateway): {
  color: "green" | "yellow" | "purple" | "blue" | "gray"; label: string
} => {
  switch (payment_gateway) {
    case "FEDAPAY":
      return { color: "green", label: "Fedapay" }
    case "STRIPE":
      return { color: "purple", label: "Stripe" }
    case "MONEROO":
      return { color: "blue", label: "Moneroo" }
    case "MANUAL":
      return { color: "gray", label: "Manuel" }
    case "INTERNAL":
      return { color: "gray", label: "Interne" }
    default:
      return { color: "gray", label: payment_gateway }
  }
}

export const getDirectionLabel = (direction: WalletTransactionDirection, transactionType: WalletTransactionType): string => {
  let label = "Débit"
  if (direction === "CREDIT") {
    label = "Crédit"
  }
  const transactionTypeLabel = WALLET_TRANSACTION_TYPE_LABELS[transactionType]
  return `${label} - ${transactionTypeLabel}`
}
